module.exports = __webpack_public_path__ + "static/media/error.c292ff59.png";